var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85336 12C3.85336 7.65938 7.42567 4 11.9999 4C16.5743 4 20.1466 7.65938 20.1466 12C20.1466 16.3406 16.5743 20 11.9999 20C7.42567 20 3.85336 16.3406 3.85336 12ZM11.9999 2C6.5522 2 2 6.3995 2 12C2 17.6005 6.5522 22 11.9999 22C17.4478 22 22 17.6005 22 12C22 6.3995 17.4478 2 11.9999 2ZM11.9999 10C11.4882 10 11.0733 9.55228 11.0733 9V8C11.0733 7.44772 11.4882 7 11.9999 7C12.5117 7 12.9266 7.44772 12.9266 8V9C12.9266 9.55228 12.5117 10 11.9999 10ZM11.9999 17C11.4882 17 11.0733 16.5523 11.0733 16V12C11.0733 11.4477 11.4882 11 11.9999 11C12.5117 11 12.9266 11.4477 12.9266 12V16C12.9266 16.5523 12.5117 17 11.9999 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon24);
export default __webpack_public_path__ + "static/media/info-icon-24.b852acdadd07a4e8a1fa6f96f4bc2724.svg";
export { ForwardRef as ReactComponent };